var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.803 0.802983C8.0959 0.51009 8.57077 0.51009 8.86366 0.802983L13.5303 5.46965C13.8232 5.76254 13.8232 6.23742 13.5303 6.53031L8.86366 11.197C8.57077 11.4899 8.0959 11.4899 7.803 11.197C7.51011 10.9041 7.51011 10.4292 7.803 10.1363L11.1893 6.74998H1C0.585786 6.74998 0.25 6.41419 0.25 5.99998C0.25 5.58577 0.585786 5.24998 1 5.24998H11.1893L7.803 1.86364C7.51011 1.57075 7.51011 1.09588 7.803 0.802983Z",
    fill: "#1A73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowIcon);
export default __webpack_public_path__ + "static/media/blueArrowIcon.c6421158f3c7b333fbff5c7a76e3f8a6.svg";
export { ForwardRef as ReactComponent };